import { NgClass } from '@angular/common'
import { Component, inject, Input, LOCALE_ID } from '@angular/core'
import { ControlContainer, NgForm, FormsModule } from '@angular/forms'

import { DatePicker } from 'primeng/datepicker'
import { InputText } from 'primeng/inputtext'
import { Tooltip } from 'primeng/tooltip'
import { ArchiveDocumentField, ArchiveDocumentForm } from '@app/interfaces/archive-documents'
import { UtilitiesService } from '@app/services/utilities.service'
import { DetailMode } from '@app/components/generic/generic.constants'
import { ActivityFieldComponent } from '../../fields/activity-field.component'
import { AssetCategoriesFieldComponent } from '../../fields/asset-categories-field.component'
import { BalzacBookFieldComponent } from '../../fields/balzac-book-field.component'
import { BudgetLinesFieldComponent } from '../../fields/budget-line-field.component'
import { CountryFieldComponent } from '../../fields/country-field.component'
import { LandlordFieldComponent } from '../../fields/landlord-field.component'
import { PartnerFieldComponent } from '../../fields/partner-field.component'
import { PlaceFieldComponent } from '../../fields/place-field.component'
import { ProgramPlaceFieldComponent } from '../../fields/program-place-field.component'
import { ProjectContractsFieldComponent } from '../../fields/project-contracts-field.component'
import { SupplierFieldComponent } from '../../fields/supplier-field.component'
import { ThirdPartyCodeFieldComponent } from '../../fields/third-party-code-field.component'
import { VoucherCodeFieldComponent } from '../../fields/voucher-code-field.component'
import { RequiredFieldTextComponent } from '../../required-field-text.component'

@Component({
  selector: 'app-type-generic',
  templateUrl: 'type-generic.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  imports: [
    Tooltip,
    FormsModule,
    InputText,
    NgClass,
    RequiredFieldTextComponent,
    DatePicker,
    CountryFieldComponent,
    PlaceFieldComponent,
    ProjectContractsFieldComponent,
    ActivityFieldComponent,
    VoucherCodeFieldComponent,
    BalzacBookFieldComponent,
    LandlordFieldComponent,
    SupplierFieldComponent,
    ThirdPartyCodeFieldComponent,
    BudgetLinesFieldComponent,
    AssetCategoriesFieldComponent,
    ProgramPlaceFieldComponent,
    PartnerFieldComponent,
  ],
})
export class TypeGenericComponent {
  public readonly utilitiesService = inject(UtilitiesService)
  public readonly locale = inject(LOCALE_ID)

  @Input() public document?: ArchiveDocumentForm
  @Input() public documentFields: ArchiveDocumentField[] = []
  @Input() public mode: string = 'normal'
  // Whether we should 'respect' the fields' request to be required: in bulk update mode this will be false,
  // in order to allow for 'partial setting' in the bulk context
  @Input() public respectRequired: boolean = true

  public filterLabelField = 'label_en'
  protected readonly DetailMode = DetailMode

  constructor () {
    if (this.locale === 'fr') {
      this.filterLabelField = 'label_fr'
    }
  }

  /**
   * Set the value of the given field/value on the current document
   */
  setDoc (fieldName: string, value: unknown): void {
    if (!this.document) return
    this.document[fieldName] = value
  }

  /**
   * Return the value of the given field/value of the current document.
   *
   * Given that we don't know what field will be requested this returns `unknown`.
   */
  getDoc (fieldName: string): unknown {
    if (!this.document) return
    return this.document[fieldName]
  }
}
